import {
  ClipboardDocumentCheckIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/outline";

import type { FeatureMetadata } from "../feature.types";
import {
  buildCrudPermissions,
  permissionId,
  createLazyPlaceholderPage,
} from "../shared/featureFactories";

const configs = [
  {
    id: "lesson-plans",
    label: "Lesson Plans",
    path: "/lesson-plans",
    icon: ClipboardDocumentCheckIcon,
    order: 7,
    permissions: buildCrudPermissions("Academics", "LessonPlans"),
  },
  {
    id: "syllabus",
    label: "Syllabus",
    path: "/syllabus",
    icon: RectangleStackIcon,
    order: 8,
    permissions: buildCrudPermissions("Academics", "Syllabus", {
      delete: permissionId("Academics", "Syllabus", "edit"),
    }),
  },
] as const satisfies ReadonlyArray<{
  id: string;
  label: string;
  path: string;
  icon: FeatureMetadata["navigation"]["icon"];
  order: number;
  permissions: FeatureMetadata["permissions"];
}>;

export const ACADEMICS_PLACEHOLDER_FEATURES: readonly FeatureMetadata[] = configs.map(
  ({ id, label, path, icon, order, permissions }) => ({
    id,
    moduleName: "academics",
    navigation: { label, path, icon, order },
    permissions,
    route: {
      path,
      element: createLazyPlaceholderPage(label),
    },
    readiness: "live",
  }),
);
